module.exports = __webpack_public_path__ + "static/media/1.fc2d5046.JPG";